export const QUOTEFLOW = 'quoteflow';
export const MDA = 'MyDigitalAgency';

interface AddSource {
  isMDA?: boolean;
}

export const addSourceValue = ({ isMDA }: AddSource) => {
  if (isMDA) {
    return MDA;
  } else {
    return QUOTEFLOW;
  }
};

export const addSource = (sources: AddSource) => ({
  source: addSourceValue(sources),
  sourceVersion: import.meta.env.VITE_APP_GIT_SHA,
});
